export class StepsModel {
    image: string
    order: number
    subtitle: string
    title: string
    constructor(obj: any = null) {
      this.image = obj?.image
      this.order = obj?.order || 0
      this.subtitle = obj?.subtitle
      this.title = obj?.title
    }
  }


export class OnboardingModel {
  id: string
  buttom_text: string
  steps: StepsModel[]
  skipable: boolean
  constructor(obj: any = null) {
    this.id = obj?.id
    this.buttom_text = obj?.store
    this.steps = obj?.steps ? obj?.steps.map((i: any) => (new StepsModel(i))) : []
    this.skipable = obj?.skipable || false
}
}

